import { render, staticRenderFns } from "./picChecklist.vue?vue&type=template&id=2cb2c913&scoped=true"
import script from "./picChecklist.vue?vue&type=script&lang=js"
export * from "./picChecklist.vue?vue&type=script&lang=js"
import style0 from "./picChecklist.vue?vue&type=style&index=0&id=2cb2c913&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cb2c913",
  null
  
)

export default component.exports